import { render, staticRenderFns } from "./DuplicateIcon.vue?vue&type=template&id=dc990a4c&scoped=true"
import script from "./DuplicateIcon.vue?vue&type=script&lang=js"
export * from "./DuplicateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc990a4c",
  null
  
)

export default component.exports